import type { Vehicle } from '../../data/vehicles'
import { getLocalizedPath } from '../../i18n/routes'
import { Link } from '../../ui/Link'
import { useInventoryTranslation } from './useInventoryTranslation'
import { VehicleFacts } from './VehicleFacts'
import { VehicleImage, vehicleLabel } from './VehicleImage'

export function VehicleCard({ vehicle }: { vehicle: Vehicle }) {
  const { language, t } = useInventoryTranslation()
  const label = vehicleLabel(vehicle)

  return (
    <article className="inventory-card">
      <Link
        className="inventory-card__media-link"
        to={getLocalizedPath('vehicle', language, { slug: vehicle.slug })}
        tabIndex={-1}
        aria-hidden="true"
      >
        <VehicleImage vehicle={vehicle} image={vehicle.images[0]} className="inventory-card__image" />
      </Link>
      <div className="inventory-card__body">
        <p className="inventory-card__make">{vehicle.make}</p>
        {vehicle.offerType === 'rental' ? <p className="inventory-card__offer">{t('rentalOffer')}</p> : null}
        <h2>{vehicle.model}</h2>
        <VehicleFacts vehicle={vehicle} compact />
        <p className="inventory-card__reference">{t('reference', { reference: vehicle.id })}</p>
        <Link
          className="inventory-card__action"
          variant="text"
          to={getLocalizedPath('vehicle', language, { slug: vehicle.slug })}
          aria-label={t('cardOpen', { vehicle: label })}
        >
          {t('cardOpen', { vehicle: label })}
        </Link>
      </div>
    </article>
  )
}
